import script from "./news-configuration-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./news-configuration-modal.vue?vue&type=script&setup=true&lang=ts"

import "./news-configuration-modal.vue?vue&type=style&index=0&id=01c16332&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c16332"]])

export default __exports__